import React from 'react';
import { ArrowRight, Star } from 'lucide-react';
const MAIN_PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/bztRYWvrArTsX1B4asVurq/Cover_1.png';
export function HeroSection() {
  const scrollToPurchase = () => {
    document.getElementById('purchase')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-24 pb-16 px-4 md:pt-32 md:pb-24 bg-gradient-to-b from-slate-950 to-slate-900 overflow-hidden" data-id="element-72">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-73">
        <div className="absolute top-20 left-1/4 w-96 h-96 bg-[#FF6B35]/10 rounded-full blur-3xl" data-id="element-74"></div>
        <div className="absolute bottom-20 right-1/4 w-80 h-80 bg-[#E63946]/10 rounded-full blur-3xl" data-id="element-75"></div>
      </div>

      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center relative z-10" data-id="element-76">
        <div className="text-left space-y-6" data-id="element-77">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#FF6B35]/10 border border-[#FF6B35]/20 text-[#FF6B35] text-sm font-bold tracking-wider uppercase" data-id="element-78">
            <span className="w-2 h-2 rounded-full bg-[#FF6B35] animate-pulse" data-id="element-79"></span>
            Sistema Probado
          </div>

          <h1 className="text-4xl md:text-6xl font-extrabold text-white leading-tight tracking-tight" data-id="element-80">
            Cómo gustar, conectar y generar química{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FF6B35] to-[#E63946]" data-id="element-81">
              SIN fingir
            </span>
          </h1>

          <p className="text-xl text-slate-300 leading-relaxed max-w-lg" data-id="element-82">
            Deja de usar frases raras y empieza a proyectar una atracción real.
            El sistema definitivo para hombres que quieren resultados sin perder
            su esencia.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 pt-4" data-id="element-83">
            <button onClick={scrollToPurchase} className="group bg-[#E63946] hover:bg-[#d32f2f] text-white text-lg font-bold py-4 px-8 rounded-lg shadow-[0_0_20px_rgba(230,57,70,0.3)] hover:shadow-[0_0_30px_rgba(230,57,70,0.5)] transition-all duration-300 flex items-center justify-center gap-2" data-id="element-84">
              QUIERO CAMBIAR MI VIDA
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-85" />
            </button>
          </div>

          <div className="flex items-center gap-4 text-sm text-slate-400 pt-2" data-id="element-86">
            <div className="flex text-yellow-500" data-id="element-87">
              <Star className="w-4 h-4 fill-current" data-id="element-88" />
              <Star className="w-4 h-4 fill-current" data-id="element-89" />
              <Star className="w-4 h-4 fill-current" data-id="element-90" />
              <Star className="w-4 h-4 fill-current" data-id="element-91" />
              <Star className="w-4 h-4 fill-current" data-id="element-92" />
            </div>
            <span data-id="element-93">+1,500 hombres han usado este sistema</span>
          </div>
        </div>

        {/* Product Image */}
        <div className="relative mx-auto w-full max-w-md md:max-w-lg" data-id="element-94">
          <div onClick={scrollToPurchase} className="relative z-10 cursor-pointer transform transition-all duration-500 hover:scale-105 hover:-rotate-1" data-id="element-95">
            <img src={MAIN_PRODUCT_IMAGE} alt="ATRACCIÓN REAL - El Manual Definitivo" className="w-full h-auto rounded-lg shadow-2xl shadow-purple-900/30" data-id="element-96" />
            {/* Glow effect behind image */}
            <div className="absolute -inset-4 bg-gradient-to-r from-purple-600/20 via-pink-500/20 to-purple-600/20 rounded-2xl blur-2xl -z-10" data-id="element-97"></div>
          </div>

          {/* Shadow/Reflection */}
          <div className="absolute -bottom-8 left-8 right-8 h-16 bg-purple-900/30 blur-2xl rounded-[100%]" data-id="element-98"></div>
        </div>
      </div>
    </section>;
}